<template>
    <div>
<div class="list-group">
  <li class="list-group-item">
    <h4 class="list-group-item-heading">{{ member.doctor_name }}</h4>
    <p class="list-group-item-text">Doctor's Name</p>
  </li>


  <li class="list-group-item">
    <h4 class="list-group-item-heading"><a :href="'tel:' + member.doctor_phone">{{ member.doctor_phone }}</a></h4>
    <p class="list-group-item-text">Doctor's Phone</p>
  </li>


  <li class="list-group-item">
    <h4 class="list-group-item-heading">{{ member.medical_information }}</h4>
    <p class="list-group-item-text">Medical Information</p>
  </li>
</div>
</div>




</template>

<script>


    export default {
        props: {
            member: Object,
        },

    }
</script>
